import { Abstrap } from '../../../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class TableCellInfo extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__info',
            className,
        ];
    }

}

TableCellInfo.propTypes = propTypes;

TableCellInfo.defaultProps = defaultProps;

export default TableCellInfo;
